import { render, staticRenderFns } from "./po_alignment.vue?vue&type=template&id=6e18a10a&scoped=true"
import script from "./po_alignment.vue?vue&type=script&lang=js"
export * from "./po_alignment.vue?vue&type=script&lang=js"
import style0 from "./po_alignment.vue?vue&type=style&index=0&id=6e18a10a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18a10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e18a10a')) {
      api.createRecord('6e18a10a', component.options)
    } else {
      api.reload('6e18a10a', component.options)
    }
    module.hot.accept("./po_alignment.vue?vue&type=template&id=6e18a10a&scoped=true", function () {
      api.rerender('6e18a10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/poManage/po_alignment.vue"
export default component.exports